import { Box, CircularProgress, SvgIcon } from '@material-ui/core';
import { ReactComponent as ExportIcon } from 'icons/exportButton.svg';
import React, { Component, Fragment } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppDispatch, AppState } from 'store';
import { exportListToFile } from 'store/projects/projects.actions';
import { getFileSpinnerSelector } from 'store/spinner/spinner.selectors';
import { ExportActionMenuButton } from './ExportActionsButton.styled';

interface IState {
  anchorEl: Element | null;
}

interface IProps {
  disabled?: boolean;
}

interface IStateProps {
  fileSpinner: boolean;
}

interface IDispatchProps {
  exportListToFile: () => void;
}

type PropType = WithTranslation & IDispatchProps & IStateProps & IProps;

class ExportActionsButton extends Component<PropType, IState> {
  constructor(props: PropType) {
    super(props);
    this.state = {
      anchorEl: null,
    };
  }

  onExport = (): void => {
    this.props.exportListToFile();
  };

  render(): JSX.Element {
    const { t, fileSpinner, disabled } = this.props;

    return (
      <Fragment>
        <ExportActionMenuButton onClick={this.onExport} disabled={fileSpinner || disabled}>
          {fileSpinner ? (
            <CircularProgress color="secondary" size={24} />
          ) : (
            <>
              <SvgIcon component={ExportIcon} />
              <Box fontWeight="500">{t('queue.export')}</Box>
            </>
          )}
        </ExportActionMenuButton>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AppDispatch>): IDispatchProps => ({
  exportListToFile: (): AppDispatch => dispatch(exportListToFile()),
});

const mapStateToProps = (state: AppState): IStateProps => ({
  fileSpinner: getFileSpinnerSelector(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ExportActionsButton));
